module.exports = {
      id: "user_signin_icon-usage",
      viewBox: "0 0 11 12",
      url: __webpack_public_path__ + "svg-sprite-39ec39c5b3d32c0adb9732979a5c9627.svg#user_signin_icon",
      toString: function () {
        return this.url;
      }
    }